export default "__VITE_ASSET__PSm54UPB__"